import { render } from "./RejectAction.vue?vue&type=template&id=5160b406"
import script from "./RejectAction.vue?vue&type=script&lang=js"
export * from "./RejectAction.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__